// 产品属性
import * as type from "../mutation-types"
const state = {
  data:window.localStorage.getItem("productAttribute") || ""
}

const getters = {
  getproductAttribute:state=>state.data
}

const mutations = {
  [type.USER_OUT_LOGIN](state){
    state.data = null
  }
}

const actions = {
  onUse(response){
    window.localStorage.setItem("productAttribute",response)
  },
  outLogin({commit}){
    commit(type.USER_OUT_LOGIN)
    window.localStorage.removeItem("productAttribute")
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}